import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

import { POPMaterial, ProjectMedia } from 'src/app/models/project.model';
import { CutoffService } from 'src/app/services/cutoff.service';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';

import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-new-pop-material',
  templateUrl: './new-pop-material.component.html',
  styleUrls: ['./new-pop-material.component.scss']
})
export class NewPopMaterialComponent implements OnInit {
  dataR!: any;
  mattypes!: Array<string>;
  media!: any;
  reglasAlcance: any[] = [];
  alcance: string = '';
  atributosSucursales = ['DANGLER', 'MATERIAL', 'ATRIBUTO X'];
  comparadores = ['Igual a', 'Mayor o igual que', 'Menor o igual que'];
  atributos : any[] = [];

  idProyecto : number = 0;
  idProyectoCamp : number = 0;
  sucursalesCount = 0;
  isEdit : boolean = false;
  idMedio : number = 0;
  idPOP : number = 0;
  hasPosicion : boolean = false;
  generate_config : boolean = false;
  isQuantity : boolean = false;
  prioridadConf : any[] = [{id: 0, nombre: '', multiplicador : ''}]
  generatePoPs : boolean = false;
  generateSettings : any = {
    cantidadPoPs : 1,
    nombre: "",
    postfijo : "",
  }

  readonly separatorKeysCodes = [ENTER, COMMA] as const;


  constructor(@Inject(MAT_DIALOG_DATA) public data : any, public dref: MatDialogRef<NewPopMaterialComponent>,
    private _main :MainService, private _cutoff : CutoffService, private _projectService : ProjectsService
  ) { }

  ngOnInit(): void {
    this.media = this.data.medio;
    this.idMedio = this.data.medio.id;
    this.isEdit = this.data.isEdit;
    this.idProyectoCamp = this.data.medio.id_proy_camp;

    if(!this.isEdit){
      this.dataR = {
        nombre: '',
        posiciones: 0,
        prioridad: null,
        precio: 0,
        cantidad: 0,
        reglas: []
      };
    }else{
      this.idPOP = this.data.pop.id;
      console.log("EDIT POP",this.data);
      this.dataR = {
        nombre: this.data.pop.nombre,
        posiciones: this.data.pop.posiciones,
        prioridad: this.data.pop.prioridad,
        reglas  : this.data.pop.sucursales_filtro? JSON.parse(this.data.pop.sucursales_filtro) : []
      };
        this.hasPosicion = Number(this.dataR.posiciones) > 0;
        this.reglasAlcance = this.data.pop.sucursales_filtro? JSON.parse(this.data.pop.sucursales_filtro) : [];  
     
    }

    // { nombre, id_proyecto_medio, prioridad, posiciones, sucursales_filtro } 
    this.getAtributos();
    this.calculateStores();
  }

  close(): void { this.dref.close(); }


  invalidInput(): boolean {
    const posiciones = Number(this.dataR.posiciones);
    return !this.dataR.nombre?.trim() ||
      (this.hasPosicion && (!Number.isInteger(posiciones) || posiciones < 1));
  }

  numericalAtributes : any;

  onlyNumericalAtributos(){
    this.numericalAtributes = this.atributos.filter((x:any)=> x.type_id == 4 || x.type_id == 6 );
    return this.numericalAtributes;
  }

  mirror(event: KeyboardEvent): void {
    const input: HTMLInputElement = event.target as HTMLInputElement;
    
    if (event.key === 'ArrowUp') {
      event.preventDefault(); 
      input.value = Math.max(1, (parseInt(input.value, 10) || 0) - 1).toString(); // Arrow up subtracts
    } else if (event.key === 'ArrowDown') {
      event.preventDefault(); // Prevent default scrolling behavior.
      input.value = ((parseInt(input.value, 10) || 0) + 1).toString(); // Arrow down adds
    }

    this.dataR.prioridad = parseInt(input.value, 10);
  }


  agregarRegla() {
    this.reglasAlcance.push({
      nombre: null,
      id: null,
      operador: 1,
      valor: null
    });
  }

  eliminarRegla(index: number) {
    this.reglasAlcance.splice(index, 1);
    this.calculateStores(); 
  }

  getRanges(rangeSelect : any){
    return rangeSelect.split("-");
  }

  converToObject(obj: string){
    try{
      return JSON.parse(obj);
    }catch(ex){
      return [];
    }
  }

  setItemName(value : any, rule : any){
    const selectedAtributo = this.atributos.find(x => x.id === value);
    if (selectedAtributo) {
        rule.nombre = selectedAtributo.name;
     
        rule.operador = 1; 
        rule.valor = null; 

        const validTypesForEquality = [1, 3, 4, 5, 6];
        if (!validTypesForEquality.includes(selectedAtributo.type_id)) {
          rule.operador = 1; 
        }
    }
    this.calculateStores(); 
  }

  onOperadorChange(rule: any) {
 
    const item = this.getItem(rule.id);
    if (rule.operador === 4 && item && item.type_id === 3) {
      
      if (!Array.isArray(rule.valor)) rule.valor = [];
    } else {
      rule.valor = null;
    }
    this.calculateStores(); 
  }


  private validateSingleRangeValue(value: string, item: any): number | null {
    if (!item || item.type_id !== 4 || value === null || value === '') {
      return Number(value);
    }

    const [min, max] = this.getRanges(item.select_data).map(Number);
    const numValue = Number(value);

    if (isNaN(numValue)) {
      Swal.fire({
        icon: 'error',
        title: 'Valor inválido',
        text: `"${value}" no es un número válido para este rango.`
      });
      return null;
    }

    if (numValue < min) {
      Swal.fire({
        icon: 'warning',
        title: 'Valor fuera de rango',
        text: `El valor "${item.name}" no puede ser menor que ${min}.`
      });
      return min;
    } else if (numValue > max) {
      Swal.fire({
        icon: 'warning',
        title: 'Valor fuera de rango',
        text: `El valor "${item.name}" no puede ser mayor que ${max}.`
      });
      return max;
    }
    return numValue;
  }

  addChip(rule: any, event: MatChipInputEvent): void {
    const input = event.input;
    let value = (event.value || '').trim(); 
    const item = this.getItem(rule.id); 

    if (value && rule.operador === 4) {
      if (!Array.isArray(rule.valor)) {
        rule.valor = [];
      }


      if (item && item.type_id === 4) {
        const validatedValue = this.validateSingleRangeValue(value, item);
        if (validatedValue !== null) { 
          value = String(validatedValue); 
          if (!rule.valor.includes(value)) { 
            rule.valor.push(value);
            this.calculateStores();
          }
        }
      } else { 
        if (!rule.valor.includes(value)) { 
          rule.valor.push(value);
          this.calculateStores();
        }
      }
    }

    if (input) {
      input.value = '';
    }
  }

  removeChip(rule: any, chip: string): void {
    if (!Array.isArray(rule.valor)) {
      return;
    }
    const index = rule.valor.indexOf(chip);

    if (index >= 0) {
      rule.valor.splice(index, 1);
      this.calculateStores(); 
    }
  }

  agregarRegl2a(list : any) {
    if(!list){
      list = [];
    }
    list.push({
      id: 0,
      nombre:  '',
      multiplicador: 1
    });
  }

  eliminarRegla2(index: number, list :any) {
    list.splice(index, 1);
  }

  setItemName2(value : any, rule : any){
    const selectedAtributo = this.atributos.find((x:any) => x.id === value);
    if (selectedAtributo) {
        rule.nombre = selectedAtributo.name;
    }
  }


  getItem(atribute_id : any) : any{
    return this.atributos.filter(x=>  x.id === atribute_id)[0];
  }

  loadedcal : boolean = false;

  validateRangeAndCalculate(regla: any) {
    const item = this.getItem(regla.id);
    // Validar solo para el tipo 'Rango' (type_id 4) y si hay un valor
    if (item && item.type_id === 4 && regla.valor !== null && regla.valor !== '') {
      const [min, max] = this.getRanges(item.select_data).map(Number);
      const valor = Number(regla.valor);

      if (valor < min) {
        regla.valor = min; 
        Swal.fire({
          icon: 'warning',
          title: 'Valor fuera de rango',
          text: `El valor no puede ser menor que ${min}. Se ha ajustado automáticamente.`
        });
      } else if (valor > max) {
        regla.valor = max; 
        Swal.fire({
          icon: 'warning',
          title: 'Valor fuera de rango',
          text: `El valor no puede ser mayor que ${max}. Se ha ajustado automáticamente.`
        });
      }
    }
    this.calculateStores();
  }

  calculateStores(){
    this.loadedcal =  false;
    if(this.reglasAlcance.length  != 0){
          this._cutoff.getCutOffFile(this.idProyectoCamp, [], this.reglasAlcance).then((x:any)=>{
               this.sucursalesCount = x.length;
               console.log(x);
                this.loadedcal =  true;
           });
    }
    //this.sucursalesCount = this._cutoff.filtrarSucursales(this.reglasAlcance).length;
  }

  getAtributos(){
    this._main.ShowLoading();7
    this._cutoff.getAtributos().subscribe((x: any) => {
      this._main.HideLoading();

      this.atributos = x.data;
      this.onlyNumericalAtributos()
    });
  }

  trackByFn(index: number, item: any): number {
    return index;
  }

  

  register(): void {  
    if (this.invalidInput()) return;
    this.dataR.posiciones = this.hasPosicion ? Number(this.dataR.posiciones) : 0;
        // { nombre, id_proyecto_medio, prioridad, posiciones, sucursales_filtro } 
    if (this.generate_config && (this.dataR.precio < 0 || !/^-?\d+(\.\d+)?$/.test(String(this.dataR.precio)) )) {
      Swal.fire({
        icon: 'warning',
        title: 'Datos incorrectos',
        text: 'Los datos ingresados no son validos.'
      });
      
    } else {
    if(!this.generatePoPs){
          let registerData = {id_proyecto_medio : this.idMedio, nombre : this.dataR.nombre, prioridad : this.dataR.prioridad, posiciones : this.dataR.posiciones, sucursales_filtro : JSON.stringify(this.reglasAlcance),
          precio : this.dataR.precio, cantidad : this.isQuantity? this.dataR.cantidad : 0, reglas_distribucion : JSON.stringify(this.prioridadConf), generate_config : this.generate_config
          }

      Swal.fire({
       icon: 'info',
       title: 'Guardando...',
       allowEscapeKey: false,
       allowOutsideClick: false,
       showConfirmButton: false,
       didOpen: () => {
         Swal.showLoading();
       }
     });

     this._projectService.createPOPs(registerData).subscribe(
       (result:any) => {
         if(result.message == "Success") {
           Swal.fire({
             icon: 'success',
             title: 'Guardado',
             html: 'POP guardado correctamente'
           }).then(() => {            
             this.dref.close(this.dataR);
            
           });
         }
       },
       (err:any) => {
         console.log(err);
         Swal.fire({
           icon: 'error',
           title: 'Error al guardar',
           text: 'Ocurrió un error al guardar los registros, por favor vuelva a intentarlo.'
         });
       }
     );

    }else{

     let pops: any= [];
      
        for (let i = 1; i <= this.generateSettings.cantidadPoPs; i++) {
          let postfijoParte = this.generateSettings.postfijo ? ` ${this.generateSettings.postfijo}` : '';
              pops.push({id_proyecto_medio : this.idMedio, nombre : `${this.dataR.nombre}${postfijoParte}${i}`, prioridad : this.media.formato == 2? i: 0, posiciones : this.dataR.posiciones, sucursales_filtro : JSON.stringify(this.reglasAlcance),
              precio : this.dataR.precio, cantidad : this.isQuantity? this.dataR.cantidad : 0, reglas_distribucion : JSON.stringify(this.prioridadConf), generate_config : this.generate_config
            });
        }
        
      this._projectService.createPOPsMultiple(pops).subscribe(
       (result:any) => {
         if(result.message == "Success") {
           Swal.fire({
             icon: 'success',
             title: 'Guardado',
             html: 'POP guardado correctamente'
           }).then(() => {            
             this.dref.close(this.dataR);
            
           });
         }
       },
       (err:any) => {
         console.log(err);
         Swal.fire({
           icon: 'error',
           title: 'Error al guardar',
           text: 'Ocurrió un error al guardar los registros, por favor vuelva a intentarlo.'
         });
       }
     );
     
     }
    
    }

  }


edit(): void {  
  if (this.invalidInput()) return;
  this.dataR.posiciones = this.hasPosicion ? Number(this.dataR.posiciones) : 0;
  // { nombre, id_proyecto_medio, prioridad, posiciones, sucursales_filtro } 
let registerData = {id: this.idPOP, id_proyecto_medio : this.idMedio, nombre : this.dataR.nombre, prioridad : this.dataR.prioridad, posiciones : this.dataR.posiciones, sucursales_filtro : JSON.stringify(this.reglasAlcance)}

Swal.fire({
 icon: 'info',
 title: 'Guardando...',
 allowEscapeKey: false,
 allowOutsideClick: false,
 showConfirmButton: false,
 didOpen: () => {
   Swal.showLoading();
 }
});

this._projectService.editPOPs(registerData).subscribe(
 (result:any) => {
   if(result.message == "Success") {
     Swal.fire({
       icon: 'success',
       title: 'Guardado',
       html: 'POP guardado correctamente'
     }).then(() => {            
       this.dref.close(this.dataR);
     });
   }
 },
 (err:any) => {
   console.log(err);
   Swal.fire({
     icon: 'error',
     title: 'Error al guardar',
     text: 'Ocurrió un error al guardar los registros, por favor vuelva a intentarlo.'
   });
 }
);


}

  
}
